import React from "react";
import CertificationItem from "./CertificationItem";
import certificationData from "../Data/CertificationCourses.json"; // Asegúrate de importar el JSON correctamente
import circle from "../Assets/line_circle.png";

export const CertificationGroup = () => {
  return (
    <div>
     
      <div className="certification-cont"> 
         <div className="form"> 
         <h1 className="certification">Certifications </h1>
          <img src={circle} alt="icon" className="icon-circle" />
        </div>
        <div className="map">
          {certificationData.certifications.map((certification, index) => (
            <CertificationItem
              key={index}
              title={certification.title} 
              date={certification.date}
              provider={certification.provider}
             
              description={certification.description}
            />
          ))}
        </div>
    
      </div>
    </div>
  );
};
